export default __webpack_public_path__ + "static/media/Sophie_9781843629535.50af4034.jpg";